export default __webpack_public_path__ + "static/media/shield.57e44387.svg";